// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("./PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql = require("../../../__generated__/ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.bs.js");

let convertFragment = ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ForSalePropertyAttributes__MultiUnit(props) {
  let match = RescriptRelay_Fragment.useFragment(ForSalePropertyAttributesMultiUnit_multiUnitProperty_graphql.node, convertFragment, props.propertyType);
  let numberOfUnits = match.numberOfUnits;
  let attributes_0 = [
    numberOfUnits.toString(),
    numberOfUnits === 1 ? "Unit" : "Units"
  ];
  let attributes_1 = props.displayPropertyType ? ({
      hd: [
        match.displayName,
        "Empty"
      ],
      tl: /* [] */0
    }) : /* [] */0;
  let attributes = {
    hd: attributes_0,
    tl: attributes_1
  };
  return JsxRuntime.jsx(PropertyAttributes.make, {
    propertyAttributes: attributes,
    size: props.size
  });
}

let make = ForSalePropertyAttributes__MultiUnit;

exports.PropertyTypeFragment = PropertyTypeFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
